import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
    OnboardingState,
    ImportFileEntry,
    RevenueSign,
    INITIAL_ONBOARDING_STATE,
} from '../models/onboarding-state.model';

@Injectable({ providedIn: 'root' })
export class OnboardingStateService {
    private readonly _state$ = new BehaviorSubject<OnboardingState>(INITIAL_ONBOARDING_STATE);

    /** Full state stream — readable by all step components and the parent. */
    readonly state$ = this._state$.asObservable();

    get snapshot(): OnboardingState {
        return this._state$.value;
    }

    // ── Erp ───────────────────────────────────────────────────────────────────

    setSelectedErp(
        erpId: string | null,
        erpName: string | null = null,
        defaultSignConvention: RevenueSign | null = null,
    ): void {
        this._patch({ erp: { selectedErpId: erpId, selectedErpName: erpName, defaultSignConvention } });
    }

    // ── Import ────────────────────────────────────────────────────────────────

    setImportFileEntries(entries: ImportFileEntry[]): void {
        this._patch({ import: { ...this._state$.value.import, fileEntries: entries } });
    }

    // ── Field Mapping ─────────────────────────────────────────────────────────

    setFieldMappingValidity(allMandatoryMapped: boolean): void {
        this._patch({ fieldMapping: { allMandatoryMapped } });
    }

    // ── Revenue Format ────────────────────────────────────────────────────────

    setRevenueSign(sign: RevenueSign | null): void {
        this._patch({ revenueFormat: { revenueSign: sign } });
    }

    // ── Chart of Accounts ─────────────────────────────────────────────────────

    setChartOfAccountsCategories(categories: string[]): void {
        this._patch({ chartOfAccounts: { categories } });
    }

    // ── Reset ──────────────────────────────────────────────────────────────────

    reset(): void {
        this._state$.next(INITIAL_ONBOARDING_STATE);
    }

    // ── Private ───────────────────────────────────────────────────────────────

    private _patch(patch: Partial<OnboardingState>): void {
        this._state$.next({ ...this._state$.value, ...patch });
    }
}
